import Vue from "vue";

/**
 * 激活列表
 * @param params
 * @returns {*}
 */
export function getCustomerActivationPage(params) {
    return Vue.axios({
        url: '/api/customer_activation/page',
        method: 'get',
        params
    })
}

export function runCustomerActivationScript(params) {
    return Vue.axios({
        url: '/api/customer_activation/runScript',
        method: 'get',
        params
    })
}

export function deleteCustomerActivation(params) {
    return Vue.axios({
        url: '/api/customer_activation/delete',
        method: 'get',
        params
    })
}